import { useEffect, useState } from 'react';
import { speechEngine } from '@/services/speech/SpeechEngine';
import { toVoiceOption, type VoiceOption } from '@/services/speech/voiceAssignment';

/** Voice list, resolved once the async `voiceschanged` event has fired. */
export function useVoices(): { voices: VoiceOption[]; loading: boolean; supported: boolean } {
  const [voices, setVoices] = useState<VoiceOption[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    void speechEngine.loadVoices().then((list) => {
      if (cancelled) return;
      setVoices(list.map(toVoiceOption));
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  return { voices, loading, supported: speechEngine.supported };
}
